"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_focus_lock_1 = __importDefault(require("react-focus-lock"));
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("../Box"));
var ModalPortal_1 = __importDefault(require("./ModalPortal"));
var FadeIn_1 = __importDefault(require("../Animation/FadeIn"));
var useDisableBodyScroll_1 = __importDefault(require("../hooks/useDisableBodyScroll"));
var IconButton_1 = __importDefault(require("../IconButton"));
var Backdrop = (0, styled_1.default)(Box_1.default)(function (_a) {
    var theme = _a.theme, zIndex = _a.zIndex, open = _a.open, backdrop = _a.backdrop;
    return ({
        position: 'fixed',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: open ? 'flex' : 'none',
        overflow: 'auto',
        // NOTE: cannot use center, will mess up overflow, could use 'safe center', but may not be supported everywhere
        // justifyContent: 'center',
        // alignItems: 'center',
        backdropFilter: backdrop ? 'blur(3px)' : 'none',
        backgroundColor: backdrop ? theme.colors.modalBackdrop : 'transparent',
        zIndex: zIndex === undefined ? theme.zIndices.modal : zIndex
    });
});
var CloseButton = (0, styled_1.default)(IconButton_1.default)({
    position: 'absolute',
    top: 0,
    right: 0,
});
var Content = (0, styled_1.default)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        width: 'fit-content',
        height: 'fit-content',
        backgroundColor: theme.colors.white,
        // let prop set marginTop to prevent conflict
        marginRight: 'auto',
        marginBottom: 'auto',
        marginLeft: 'auto',
        boxShadow: theme.boxShadows.main
    });
});
function Modal(props) {
    var _a = props.marginTop, marginTop = _a === void 0 ? 'auto' : _a, zIndex = props.zIndex, open = props.open, onClose = props.onClose, closeIcon = props.closeIcon, closeIconProps = props.closeIconProps, backdrop = props.backdrop, closeOnBackdrop = props.closeOnBackdrop, scrollable = props.scrollable, children = props.children, styleProps = props.styleProps, id = props.id;
    var ref = (0, react_1.useRef)(null);
    (0, useDisableBodyScroll_1.default)(open, { scrollable: scrollable });
    var handleBackdropClick = function () {
        if (closeOnBackdrop && onClose) {
            onClose();
        }
    };
    var handleContentClick = function (event) {
        // prevent clicking content to close modal
        event.stopPropagation();
    };
    return (react_1.default.createElement(ModalPortal_1.default, null,
        react_1.default.createElement(react_focus_lock_1.default, { disabled: !open, autoFocus: false },
            react_1.default.createElement(Backdrop, { ref: ref, zIndex: zIndex, open: open, backdrop: backdrop, onClick: handleBackdropClick },
                react_1.default.createElement(FadeIn_1.default, { duration: 0.5, persist: true },
                    react_1.default.createElement(Content, { id: id, style: styleProps, marginTop: marginTop, onClick: handleContentClick },
                        closeIcon && (react_1.default.createElement(CloseButton, { "aria-label": 'Close', icon: 'ff-icon-cross', iconProps: __assign({ fontSize: '20px' }, closeIconProps), onClick: onClose, margin: '15px' })),
                        children))))));
}
exports.default = Modal;
